import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TableColumnComponent } from "@components/custom-table/components/column/table-column.component";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ToolRequestHistory } from "@models/tool-request-history.model";
import { TranslateService } from "@ngx-translate/core";
import { Log } from "ng2-logger";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { RequestType } from "@models/enums/request-type.enum";

@Component({
    selector: 'app-tool-request-history-table',
    templateUrl: './tool-request-history-table.component.html',
    styleUrls: ['./tool-request-history-table.component.scss']
})
export class ToolRequestHistoryTableComponent implements OnInit {
    _logger = Log.create(ToolRequestHistoryTableComponent.name);

    @ViewChild('date', {static: true}) dateColumn: TableColumnComponent;

    @Input() toolRequestHistory: ToolRequestHistory[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    filterStatusList = [];
    filterTypeList = [];

    constructor(private translateService: TranslateService) {
        this.filterStatusList = this.buildRequestStatusFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterStatusList = this.buildRequestStatusFilterColumnKeys();
            this._logger.info('onLangChange:: Language keys', this.filterStatusList);
        });

        this.filterTypeList = this.buildRequestTypeFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterTypeList = this.buildRequestTypeFilterColumnKeys();
            this._logger.info('onLangChange:: Language keys', this.filterTypeList);
        });
    }

    ngOnInit() {
        this.dateColumn.sort = {
            active: true,
            direction: 'desc'
        };
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange:: ', this.tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange:: ', this.tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange:: ', this.tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(event) {
        this._logger.info('onRowClick:: ', event);
        this.rowClick.emit(event);
    }

    buildRequestStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {
                name: this.translateService.instant("generic.statuses.new"),
                value: ToolRequestStatus.NEW
            },
            {
                name: this.translateService.instant("generic.statuses.inTransport"),
                value: ToolRequestStatus.IN_TRANSPORT
            },
            {
                name: this.translateService.instant("generic.statuses.approved"),
                value: ToolRequestStatus.APPROVED
            },
            {
                name: this.translateService.instant("generic.statuses.rejected"),
                value: ToolRequestStatus.REJECTED
            },
            {
                name: this.translateService.instant("generic.statuses.pending"),
                value: ToolRequestStatus.WAITING_FOR_APPROVAL
            },
            {
                name: this.translateService.instant("generic.statuses.closed"),
                value: ToolRequestStatus.CLOSED
            },
            {
                name: this.translateService.instant("generic.statuses.canceled"),
                value: ToolRequestStatus.CANCELED
            },
            {
                name: this.translateService.instant("generic.statuses.waitingForProcessing"),
                value: ToolRequestStatus.WAITING_FOR_PROCESSING
            },
            {
                name: this.translateService.instant("generic.statuses.processed"),
                value: ToolRequestStatus.PROCESSED
            },
            {
                name: this.translateService.instant("generic.statuses.confirmed"),
                value: ToolRequestStatus.CONFIRMED
            },
            {
                name: this.translateService.instant("generic.statuses.waitingForConfirmation"),
                value: ToolRequestStatus.WAITING_FOR_CONFIRMATION
            }
        ];
    }

    buildRequestTypeFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {
                name: this.translateService.instant("generic.types.line"),
                value: RequestType.LINE
            },
            {
                name: this.translateService.instant("generic.types.ticket"),
                value: RequestType.TICKET
            }
        ];
    }
}
